import type { SettingsDiagnosticsProbe } from "../application/services/system-settings-service.js";
import { resolveAppVersion } from "../shared/branding/app-version.js";

declare const __APP_VERSION__: string;
declare const __APP_BUILD_TIME__: string;
declare const __APP_BACKEND_ENV__: string;

/** Diagnóstico do modo navegador (`npm run dev`): sem banco, sem migrations — e diz isso. */
export const browserSettingsProbe: SettingsDiagnosticsProbe = {
  mode: "NAVEGADOR",
  appVersion() {
    // Fonte central (§ VERSÃO-02): nome e versão nunca são combinados numa só
    // string aqui — a formatação de exibição ("Versão da aplicação") é da
    // tela (settings-page.ts), este método devolve o texto de diagnóstico.
    const version = typeof __APP_VERSION__ !== "undefined" && __APP_VERSION__ ? __APP_VERSION__ : null;
    const buildNumber = typeof __APP_BUILD_TIME__ !== "undefined" && __APP_BUILD_TIME__ ? __APP_BUILD_TIME__ : null;
    const environment = typeof __APP_BACKEND_ENV__ !== "undefined" && __APP_BACKEND_ENV__ ? __APP_BACKEND_ENV__ : null;
    const appVersion = resolveAppVersion({ version, buildNumber, environment });
    if (!version) return "não informada";
    return `${appVersion.displayVersion} (${appVersion.version}, build ${appVersion.buildNumber})`;
  },
  versionInfo() {
    const version = typeof __APP_VERSION__ !== "undefined" && __APP_VERSION__ ? __APP_VERSION__ : null;
    const buildNumber = typeof __APP_BUILD_TIME__ !== "undefined" && __APP_BUILD_TIME__ ? __APP_BUILD_TIME__ : null;
    const environment = typeof __APP_BACKEND_ENV__ !== "undefined" && __APP_BACKEND_ENV__ ? __APP_BACKEND_ENV__ : null;
    return resolveAppVersion({ version, buildNumber, environment });
  },
  async database() {
    return {
      engine: "Navegador",
      detail: "Memória + localStorage deste navegador.",
      currentMigration: null,
      pendingMigrations: null,
      note: "O teste local não usa banco de dados: as migrations valem para o servidor (homologação/produção)."
    };
  },
  async pdf() {
    const { documentEngine } = await import("../infrastructure/documents/document-engine.js");
    await import("../infrastructure/documents/builders/index.js");
    return documentEngine.selfTest();
  }
};
